import { render, staticRenderFns } from "./notify_setting_dialog.vue?vue&type=template&id=57510d52"
import script from "./notify_setting_dialog.vue?vue&type=script&lang=js"
export * from "./notify_setting_dialog.vue?vue&type=script&lang=js"
import style0 from "./notify_setting_dialog.vue?vue&type=style&index=0&id=57510d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports